<div (scroll)="setScrolled($event)" cdk-scrollable class="overflow-y-auto">
  <ng-content>

  </ng-content>
</div>
